import { useEffect } from 'react'

import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Divider } from '@tribeplatform/react-ui-kit/Divider'

import { useQuery } from '../../../../hooks/useQuery.js'
import { useCurrentProductInformation } from '../hooks/useCurrentProductInformation.js'
import { useTrackCheckoutCompleted } from '../hooks/useTrackCheckoutCompleted.js'
import { CheckoutCompletedQueryParams } from '../types.js'
import { AddonsCard } from './AddonsCard.js'
import { BillingInformationCard } from './BillingInformationCard.js'
import { PlanCard } from './PlanCard.js'
import { UpgradeSuccessAlert } from './UpgradeSuccessAlert.js'

export const BillingContent = () => {
  const { isLoading, planName } = useCurrentProductInformation()
  const { success } = useQuery<CheckoutCompletedQueryParams>()
  const { trackCheckoutCompletedOnce } = useTrackCheckoutCompleted()

  useEffect(() => {
    trackCheckoutCompletedOnce()
  }, [trackCheckoutCompletedOnce])

  const isSuccessful = success === 'true'

  if (isLoading) {
    return <LoadingComponent />
  }

  return (
    <div className="flex flex-col space-y-5">
      {isSuccessful && <UpgradeSuccessAlert planName={planName} />}
      <PlanCard />
      <AddonsCard />
      <BillingInformationCard />
    </div>
  )
}

const LoadingComponent = () => {
  return (
    <>
      {[...Array(3)].map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Card key={i}>
          <Card.Header
            title={<div className="h-6 w-1/5 bg-skeleton rounded"></div>}
            description={
              <div className="h-4 w-1/3 bg-skeleton rounded mt-3"></div>
            }
          />
          <Card.Content>
            <Divider padding="none" className="-mx-6 mb-6" />
            <div className="h-6 w-1/6 bg-skeleton rounded"></div>
          </Card.Content>
        </Card>
      ))}
    </>
  )
}
